const Footer = () => (
  <footer className="bg-[#172337] text-gray-300 mt-6" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-6 py-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-xs">
      <div>
        <p className="text-[#878787] uppercase mb-3">About</p>
        <ul className="space-y-2">
          <li>Contact Us</li>
          <li>About Us</li>
          <li>Careers</li>
          <li>Stories</li>
        </ul>
      </div>
      <div>
        <p className="text-[#878787] uppercase mb-3">Help</p>
        <ul className="space-y-2">
          <li>Payments</li>
          <li>Shipping</li>
          <li>Cancellation & Returns</li>
          <li>FAQ</li>
        </ul>
      </div>
      <div>
        <p className="text-[#878787] uppercase mb-3">Policy</p>
        <ul className="space-y-2">
          <li>Return Policy</li>
          <li>Terms Of Use</li>
          <li>Security</li>
          <li>Privacy</li>
        </ul>
      </div>
      <div>
        <p className="text-[#878787] uppercase mb-3">Mail Us</p>
        <p className="leading-relaxed text-gray-400">
          BharatiCrafts, Handcrafts Lane, Bengaluru, 560034, Karnataka, India
        </p>
      </div>
    </div>
    <div className="border-t border-white/10 py-4 text-center text-[11px] text-gray-500">
      BharatiCrafts — handcrafted goods & more. Prices in ₹.
    </div>
  </footer>
);

export default Footer;
